import { Mixins, Component, ProvideReactive, Watch } from "vue-property-decorator";
import AppCompose from "./components/appCompose.vue";
import GroupType from "./components/groupType.vue";

/**
 * README: appCompose 和 merchantAppCompose 共用的业务逻辑
 * 两个路由指向同一个组件文件，vue-name-loader 会生成相同的 name 导致 keep-alive 缓存冲突。
 * 提取 mixin 后，两个页面各自有独立组件 name，缓存互不干扰。
 */
@Component({
  components: { AppCompose, GroupType }
})
export default class AppComposeMixin extends Mixins() {
  @ProvideReactive() currentTab = "1";
  brandName = "";

  @Watch("$route", { immediate: true })
  routeChange() {
    this.currentTab = "1";
    const path = this.$route.path;
    if (["/appCompose", "/merchantAppCompose"].includes(path)) {
      this.brandName = <string>this.$route.query.brandName;
    }
  }
}
